import React, {useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton
} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles'
import FolderSelector from './FolderSelector';
import CloseIcon from "@mui/icons-material/Close";

const styles = {
  root: {
  },
  highlight: {},
  title: {
    marginRight: 'auto'
  },
  dividerBox:{
    width:'100%',
    display:'flex',
    gap:'0.5em',
    alignItems:'center',
    margin:'1.5em 0',
    '& > hr':{
      flex: 1
    }
  },
  row:{
    display:'flex',
    flexWrap:'wrap',
    gap:'0.5rem',
    alignItems:'center',
  },
  label:{
    flexShrink:0,
    whiteSpace:'nowrap',
    textTransform:'uppercase',
    fontSize:'0.75rem',
    fontWeight:'600',
    color:'rgba(0,0,0,0.54)'
  },
  folderSelect:{
    flexGrow:1,
    flexBasis:'12em',
  },
  centered:{
    textAlign:'center',
  },
  actions:{
    marginTop:'2em',
  },
};

function DeleteFoldersDialog(props) {
  const {id, foldersMap, folderList, addFolder, handleDeleteSelectedAndDeleteItems, handleDeleteSelectedAndMoveItems, handleClose, open, classes } = props;
  const filtered = folderList.filter(f => !foldersMap.hasOwnProperty(f.id));
  const [selectedFolder, setSelectedFolder] = useState(filtered.length  > 0 ? filtered[0] : null);
  const itemCount = Object.entries(foldersMap||{}).map(([id, f]) => f.item_count).reduce((a, b) => a + b, 0);
  const folderIds = Object.entries(foldersMap||{}).map(([id, f]) => f.id);

  const handleDeleteDestroy = () => {
    handleDeleteSelectedAndDeleteItems(folderIds)
    handleClose();
  };
  const handleDeleteMove = () => {
    if(!selectedFolder || typeof(selectedFolder.id) === 'undefined' || !selectedFolder.id){
      return;
    }
    handleDeleteSelectedAndMoveItems(folderIds, selectedFolder.id)
    handleClose();
  };

  return !open || folderIds.length === 0 ? null : (
    <Dialog PaperProps={{id:id}}
      onClose={handleClose}
      open={open}
      fullWidth maxWidth="sm"
    >
      <DialogTitle>
        <div style={{display:'flex', flexWrap:'wrap-reverse', justifyContent:'space-between'}}>
          Delete {folderIds.length} {folderIds.length > 1 ? 'Folders' : 'Folder'}
          <IconButton onClick={handleClose} style={{width:'2rem', height:'2rem', margin:'-0.5rem 0 0 auto'}}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="moveFolderItemsMessage" style={{margin:0}}>
          Move {itemCount} items and Delete {folderIds.length} {folderIds.length > 1 ? 'folders' : 'folder'}
        </DialogContentText>
        <div className={classes.row}>
          <div className={classes.label}>
            Move To:
          </div>
          <div className={classes.folderSelect}>
            <FolderSelector
              label="Folder"
              selectedFolder={selectedFolder}
              folderList={filtered}
              addFolder={addFolder}
              handleFolderSelect={(newVal) => setSelectedFolder(newVal)}
            />
          </div>
        </div>
        <div className={classes.centered}>
          <Button variant="contained" color="primary" onClick={handleDeleteMove} disabled={filtered.length === 0}>
            Move Items and Delete Folders
          </Button>
        </div>
        <div className={classes.dividerBox}>
          <Divider/>OR<Divider/>
        </div>
        <DialogContentText id="deleteFolderItemsMessage">
          Delete {itemCount} items and Delete {folderIds.length} {folderIds.length > 1 ? 'folders' : 'folder'}
        </DialogContentText>
        <div className={classes.centered}>
          <Button variant="contained" color="primary" onClick={handleDeleteDestroy}>
            Delete Items and Delete Folders
          </Button>
        </div>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleClose}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default withStyles(styles)(DeleteFoldersDialog);
